module.exports = __webpack_public_path__ + "static/media/tire-flat.41a3ce67.svg";